
import { defineComponent } from 'vue';

export default defineComponent({
    name: "ProfileInfoComponent",

    props: ["user"],

    methods: {
        AuthStatusType(status: string) {
            let persianStatus = "";
            switch (status) {
                case 'APPROVED':
                    persianStatus = "تایید شده";
                    break;
                case 'PENDING':
                    persianStatus = "در انتظار تایید";
                    break;
                case 'REJECTED':
                    persianStatus = "رد شده";
                    break;
            }

            return persianStatus;
        }
    }
})
